<div data-toggle="buttons" class="d-flex justify-content-between">
  <input
    id="input-modal-services-duration"
    class="form-control col-7"
    type="number"
    pattern="[-\d]*"
    [formControl]="control"
    [disabled]="disabled"
    [ngClass]="{'is-invalid': control.touched && control.invalid }"
  />
  <button
    type="button"
    class="btn btn-info"
    [disabled]="disabled"
    (click)="change(5)"
  >+5</button>
  <button
    type="button"
    class="btn btn-info"
    [disabled]="disabled"
    (click)="change(-5)"
  >-5</button>
</div>
